import React from "react";

export interface IFooterProps{
  className?: string;
}

export const Footer: React.FC <IFooterProps> = ({
  className = "",
  }) => {


  return (
    <div
      className={`flex fixed bottom-0 ml-0 md:ml-60 justify-center md:justify-start md:pl-[30%] lg:pl-[35%] gap-1.5 items-center w-full py-2 text-[8px] md:text-[10px] bg-slate-100 ${className}`}
    >
      <span>Software Developed By</span>
      <a
        href='https://speedcodelabs.com/'
        target='_blank'
        rel='noopener noreferrer'
        className='font-bold text-blue-900 underline'
      >
        Speed Code Labs
      </a>
    </div>
  );
};